import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { client } from '../config/api';

export const APIProvider = ({ children }: { children: React.ReactNode }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
